(function () {
  var POLL_MS = 200;
  var POLL_MAX = 50;
  var TRIGGER_SELECTOR = '[data-tcb-tidio-chat], [data-tcb-open-chat], [data-tcb-floating-chat]';
  var brandingLoaded = false;

  function loadBrandingAssets() {
    if (brandingLoaded) return;
    var config = window.tcbTidioBranding;
    if (!config) return;
    brandingLoaded = true;

    if (config.avatar) {
      document.documentElement.setAttribute('data-tcb-tidio-avatar', config.avatar);
    }

    if (config.css && !document.querySelector('link[data-tcb-tidio-css]')) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = config.css;
      css.setAttribute('data-tcb-tidio-css', '1');
      document.head.appendChild(css);
    }

    if (config.js && !document.querySelector('script[data-tcb-tidio-js]')) {
      var js = document.createElement('script');
      js.src = config.js;
      js.defer = true;
      js.setAttribute('data-tcb-tidio-js', '1');
      document.head.appendChild(js);
    }
  }

  function enableTidioUi() {
    document.documentElement.classList.add('tcb-tidio-ready');
    if (typeof window.tcbEnableTidio === 'function') {
      window.tcbEnableTidio();
    }
  }

  function tryOpen() {
    var api = window.tidioChatApi;
    if (!api) return false;
    if (typeof api.display === 'function') api.display(true);
    if (typeof api.show === 'function') api.show();
    if (typeof api.open === 'function') {
      api.open();
      return true;
    }
    return false;
  }

  function openTidioChat() {
    loadBrandingAssets();
    enableTidioUi();
    if (tryOpen()) return;

    document.dispatchEvent(new Event('tidioChat-open'));

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (tryOpen() || attempts >= POLL_MAX) {
        window.clearInterval(timer);
      }
    }, POLL_MS);

    document.addEventListener('tidioChat-ready', function onReady() {
      document.removeEventListener('tidioChat-ready', onReady);
      tryOpen();
    });
  }

  window.tcbOpenTidioChat = openTidioChat;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger || trigger.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    openTidioChat();
  }, true);
})();
